/**
 * Questo hook personalizzato serve per avere le dimensioni nello schermo in uno stato
 * Se cambia la dimensione cambia lo stato e quindi aggiorna i componenti dove viene usato
 * Questo lo uso solo per la ProgressBar per metterla in verticale quando ha una certa dimensione
 */

import { useState, useEffect } from 'react';



/// $RM test per integrazione safari
// const getViewports = () => ({
// 	viewport: {
// 		width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
// 		height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
// 	},
// 	// ,
// 	// visualViewport: {
// 	//   width: window.visualViewport.width,
// 	//   height: window.visualViewport.height
// 	// }
// });



// dichiaro la funzione che mi da la larghezza e l'altezza
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
}

const useWindowDimensions = () => {
    // dichiaro lo stato inizializzandolo con i dati presi dalla funzione getWindowDimensions
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());


    useEffect(() => {
        // dichiaro la funzione per quando le dimensioni cambiano di cambiare lo stato
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }


        // aggiungo la funzione all'evento resize
        window.addEventListener('resize', handleResize);

        // questo serve perché se no esplode alcune volte, in caso puoi anche commentarlo
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export default useWindowDimensions;